module.exports = __webpack_public_path__ + "static/media/logistica.a0e7bb98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/servicios/logistica.svg
// module id = 165
// module chunks = 0